import {_urlEmail, _urlUserConfluence, _urlUserMattermost, _urlUserSlack, request} from "../api";
import {USER_CALENDAR_CONSTS} from "../constants";

export const GetAuthorizationUrlConfluenceService = (data) => {
    let requestData = {
        url: `${_urlUserConfluence}/confluence_auth_process_stepone`,
        method: "POST",
        data
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};

export const GetAuthorizationStateConfluenceService = (state, code) => {
    let requestData = {
        url: `${_urlUserConfluence}/confluence_auth_process_steptwo?state=${state}&code=${code}`,
        method: "GET",
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};

export const GetConfluenceSpacesService = (state, code) => {
    let requestData = {
        url: `${_urlUserConfluence}/spaces`,
        method: "GET",
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};

export const LogoutConfluenceService = () => {
    let requestData = {
        url: `${_urlUserConfluence}/token_management`,
        method: "DELETE",
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};

export const UpdateSpacesConfluenceService = (data) => {
    let requestData = {
        url: `${_urlUserConfluence}/spaces`,
        method: "POST",
        data
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};



export const GetConfluenceInfoService = () => {
    let requestData = {
        url: `${_urlUserConfluence}/token_management`,
        method: "GET",
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};

export const GetGoogleEmailInfoService = () => {
    let requestData = {
        url: `${_urlEmail}/google_auth_data`,
        method: "GET",
    };
    return dispatch => {
        return request(requestData)
            .then(async (res) => {
                await dispatch({
                    type: USER_CALENDAR_CONSTS.GET_GOOGLE_EMAIL_USER_INFO,
                    payload: res?.data
                })
            })
    };
};


export const GetGoogleEmailsListService = () => {
    let requestData = {
        url: `${_urlEmail}/list`,
        method: "GET",
    };
    return dispatch => {
        return request(requestData)
            .then(async (res) => {
                await dispatch({
                    type: USER_CALENDAR_CONSTS.GET_GOOGLE_EMAILS_LIST_INFO,
                    payload: res?.data
                })
            })
    };
};


export const UpdateGoogleEmailInfoService = (data) => {
    let requestData = {
        url: `${_urlEmail}/google_auth_data`,
        method: "POST",
        data
    };
    return request(requestData)
};

export const DisconnectGoogleEmailInfoService = (data) => {
    let requestData = {
        url: `${_urlEmail}/list`,
        method: "DELETE",
        data
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};

export const GetAuthorizationUrlMattermostService = () => {
    let requestData = {
        url: `${_urlUserMattermost}/oauth_link`,
        method: "GET"
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};

export const GiveOauthCodeMattermostService = (code, state) => {
    let requestData = {
        url: `${_urlUserMattermost}/oauth_code`,
        method: "POST",
        data: {code, state},
        withCredentials: true
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};

export const LogOutMattermostService = () => {
    let requestData = {
        url: `${_urlUserMattermost}/disconnect`,
        method: "POST"
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};

export const GetAuthorizationUrlSlackService = () => {
    let requestData = {
        url: `${_urlUserSlack}/oauth_link`,
        method: "GET"
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};

export const GiveOauthCodeSlackService = (code, state) => {
    let requestData = {
        url: `${_urlUserSlack}/oauth_code`,
        method: "POST",
        data: {code, state},
        withCredentials: true
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};


export const LogOutSlackService = () => {
    let requestData = {
        url: `${_urlUserSlack}/disconnect`,
        method: "POST"
    };
    return request(requestData)
        .then(async (res) => {
            return res?.data
        })
};